import * as React from 'react'
const SvgIcoMusiqueThema = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    {...props}
  >
    <style>
      {
        '.ICO_MusiqueThema_N_svg__st0{display:none}.ICO_MusiqueThema_N_svg__st1{display:inline}.ICO_MusiqueThema_N_svg__st3,.ICO_MusiqueThema_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_MusiqueThema_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <g id='ICO_MusiqueThema_N_svg__Calque_5'>
      <path d='M87.28 65.8h33.18l-5.85-12.64zM126.71 101.78l8.56-3.96-8.56-18.5zM72.59 72.6l-2.64 1.22 2.64 5.7zM75.35 117.47h49.21V68.26H75.35zm14.51-19.7c1.54-.61 3.1-.71 4.33-.36v-8.14c0-.02-.01-.04-.01-.06v-5.48c0-.42.34-.76.76-.76l13.67-2.53c.42 0 .76.34.76.76v3.98c.01.07.02.15.02.22v14.67c0 .2-.05.4-.14.57-.43 1.45-1.84 2.89-3.81 3.67-2.85 1.14-5.78.49-6.56-1.45-.77-1.94.91-4.43 3.75-5.56 1.53-.61 3.09-.7 4.33-.36v-9.2L96.6 89.66v10.88c0 .21-.05.4-.14.57-.43 1.45-1.84 2.89-3.81 3.67-2.85 1.14-5.78.49-6.55-1.45-.77-1.93.91-4.43 3.76-5.56' />
    </g>
  </svg>
)
export default SvgIcoMusiqueThema

